<template>
  <div ref="refChartBar"
       style="width: 100%; height: 100%;">
  </div>
</template>

<script>
export default {
  data() {
    return {
      chartBar: null, // 图表指针
      optionBar: {} // 图表参数
    }
  },
  components: {},
  props: {
    updata: {
      type: Object,
      default: () => ({
        xData: ['2月', '3月'],
        seriesData: [
          { name: '入住', values: [30, 70] },
          { name: '退租', values: [30, 70] }
        ]
      })
    }
  },
  mounted() {
    this.initOption()
  },
  beforeDestroy() {
    if (this.chartBar) this.chartBar.dispose()
  },
  watch: {
    updata: {
      handler(newData) {
        this.updateOption(newData)
      },
      // immediate: true, // 初始化后会立即触发一次
      deep: true // 深层监听 即遍历所有子对象 对性能稍有影响
    }
  },
  methods: {
    initOption() {
      this.chartBar = this.$echarts.init(this.$refs.refChartBar)
      this.updateOption(this.updata)
    },
    updateOption(newData) {
      this.optionBar = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show: true,
          top: '5%',
          left: 'center',
          textStyle: {
            fontSize: 14,
            fontWeight: 400,
            fontFamily: 'Source Han Sans SC',
            color: '#FFFFFF',
            align: 'left'
          },
          data: newData.seriesData.map((item) => item.name)
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            show: true, // 显示标签
            color: '#5C9ADD', // 标签颜色
            fontSize: 14, // 字体大小
            fontWeight: 400
            // formatter: '{value} 次', // 格式化标签文本，例如在数值后添加单位
            // rotate: 45 // 标签旋转角度，例如45度
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#4075A5',
              width: 2,
              type: 'solid' // 轴线类型，'solid'（实线）、'dashed'（虚线）、'dotted'（点线）
            }
          },
          data: newData.xData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            color: '#5C9ADD',
            fontSize: 14,
            fontWeight: 400
          },
          axisLine: {
            show: false
          },
          splitLine: {
            //背景线条
            show: true,
            lineStyle: {
              color: '#4075A5',
              type: 'dashed'
            }
          }
        },
        series: newData.seriesData.map((item) => ({
          name: item.name,
          type: 'bar',
          barMaxWidth: 50,
          data: item.values
        })),
        color: [
          {
            colorStops: [
              {
                color: '#43E2D8',
                offset: 0
              },
              {
                color: '#2F9E9513',
                offset: 1
              }
            ],
            global: false,
            type: 'linear',
            x: 0,
            x2: 1,
            y: 0,
            y2: 1
          },
          {
            colorStops: [
              {
                color: '#EBA15C',
                offset: 0
              },
              {
                color: '#ECBE8413',
                offset: 1
              }
            ],
            global: false,
            type: 'linear',
            x: 0,
            x2: 1,
            y: 0,
            y2: 1
          }
        ]
      }
      this.chartBar.setOption(this.optionBar, {
        notMerge: true // 不合并以前的配置，直接使用新的配置覆盖
        // lazyUpdate: true // 延迟更新视图，直到下一次渲染循环，这样可以批量更新多个属性而只触发一次重渲染，提高性能。
      })
    }
  }
}
</script>

<style scoped>
</style>